import React, { ReactElement } from 'react';
import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';

const FormWarehousing = ({disabledFields} : {disabledFields?: boolean}): ReactElement => {
  const { t } = useTranslation('common');

  const { TextArea } = Input;

  return (
    <div>
      <Form.Item
        label={t('misc.warehousingParticularTypesOfCargo')}
        name='warehousingParticularTypesOfCargo'
      >
        <TextArea disabled={disabledFields} />
      </Form.Item>
      <Form.Item
        label={t('misc.warehousingLocationsOfWarehousing')}
        name='warehousingLocationsOfWarehousing'
      >
        <TextArea disabled={disabledFields} />
      </Form.Item>
      <Form.Item
        label={t('misc.warehousingCurrentVolumeCapacity')}
        name='warehousingCurrentVolumeCapacity'
      >
        <TextArea disabled={disabledFields} />
      </Form.Item>
      <Form.Item
        label={t('misc.warehousingUniqueSellingPoint')}
        name='warehousingUniqueSellingPoint'
      >
        <TextArea disabled={disabledFields} />
      </Form.Item>
      <Form.Item label={t('misc.warehousingAddOnServices')} name='warehousingAddOnServices'>
        <TextArea disabled={disabledFields} />
      </Form.Item>
    </div>
  );
};

export default FormWarehousing;
